








































































import {
  GridColumn,
  GridForm,
  GridRow,
} from '@/components/grid';
import ShowGuide from '@/components/ShowGuide.vue';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  components: {
    GridColumn,
    GridForm,
    GridRow,
    ShowGuide,
  },
} as IView;
